import { Component } from '@verndale/core';
import { rovingIndex } from '@verndale/roving-ux';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      tabs: Array.from(this.el.querySelectorAll('[role="tab"]')),
      tablist: this.el,
      tabContent: this.el.querySelectorAll('.tab-panel__content'),
      select: this.el.querySelector('.tab-panel__select .field__select'),
      buttonsContainer: this.el.querySelector('.tab-panel__buttons')
    };

    const rovingIndexContainer = this.el.closest('.library-search')
      ? this.dom.buttonsContainer
      : this.el;

    rovingIndex({
      element: rovingIndexContainer,
      target: '.tab-panel__tab-btn'
    });

    this.isInit = true;

    this.initial();
  }

  addListeners() {
    this.dom.tablist.addEventListener('click', e => this.handleClick(e));
    this.dom.select.addEventListener('change', e => this.handleChange(e));
  }

  initial() {
    this.dom.select.innerHTML = '';
    const selectOptions = this.dom.select.cloneNode(true);
    this.dom.tabs.forEach(tab => {
      selectOptions.innerHTML += `<option value="${tab.getAttribute('id')}">${
        tab.innerText
      }
      </option>`;
    });
    this.dom.select.innerHTML = selectOptions.innerHTML;
    this.dom.options = this.dom.select.querySelectorAll('option');

    this.activateTab(0);
    this.activeTabId = this.dom.tabs[0].getAttribute('id');
  }

  tabChange(selectedId) {
    if (selectedId !== this.activeTabId) {
      this.deactivateTab(
        this.dom.tabs.findIndex(tab => tab.id === this.activeTabId)
      );
      this.activateTab(this.dom.tabs.findIndex(tab => tab.id === selectedId));
      this.activeTabId = selectedId;
    }
  }

  deactivateTab(tabIndex) {
    this.dom.tabs[tabIndex].classList.remove('tab-panel__tab-btn--selected');
    this.dom.tabs[tabIndex].removeAttribute('tabindex');
    this.dom.tabs[tabIndex].setAttribute('aria-selected', 'false');
    this.dom.tabContent[tabIndex].classList.remove(
      'tab-panel__content--selected'
    );
    this.dom.options[tabIndex].selected = false;
  }

  activateTab(tabIndex) {
    this.dom.tabs[tabIndex].classList.add('tab-panel__tab-btn--selected');
    this.dom.tabs[tabIndex].setAttribute('tabindex', '-1');
    this.dom.tabs[tabIndex].setAttribute('aria-selected', 'true');
    this.dom.tabContent[tabIndex].classList.add('tab-panel__content--selected');
    this.dom.options[tabIndex].selected = true;

    if (!this.isInit) this.dom.tabs[tabIndex].focus();

    this.isInit = false;
  }

  handleClick(e) {
    if (e.target.classList.contains('tab-panel__tab-btn')) {
      this.tabChange(e.target.id);
    }
  }

  handleChange(e) {
    this.tabChange(e.target.value);
  }
}

export default Module;
